const url = 'https://kind-pink-anemone-tutu.cyclic.app/addOrder'

function addOrder(data, setErrorOrder, setLoadingOrder, setCorrectOrder) {
    setLoadingOrder(true)
    fetch( url, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify(data),
    }).then((response) => response.json())
    .then((result) => {
        if (result.message != 'added') {
            setErrorOrder(result.message)
            setLoadingOrder(false)
        }else{
            setLoadingOrder(false)
            setCorrectOrder(true)
        }
    });
}

export default addOrder